import { CSSObject } from '@chakra-ui/react';

export const BetSlipEmptyContainer: CSSObject = {
  justifyContent: ['center', null, null, null, 'flex-start'],
  py: '16',
  px: ['8', null, null, null, '5'],
  color: 'white',
  textAlign: 'center',
  mx: 'auto',
};

export const BetSlipEmptyHeading: CSSObject = {
  fontFamily: 'SkranjiBold',
  fontSize: '3xl',
  fontWeight: 'bold',
  color: '#FCD236',
  lineHeight: '100%',
  textTransform: 'uppercase',
  WebkitTextStroke: '2px #A1741F',
  bg: 'linear-gradient(180deg, #FCD236 0%, #E79004 100%)',
  bgClip: 'text',
  WebkitTextFillColor: 'transparent',
};

export const BetSlipEmptyImage: CSSObject = {
  h: 'full',
  w: '15rem',
  mb: '0',
};

export const BetSlipEmptySubheading: CSSObject = {
  fontWeight: 'medium',
  fontSize: 'sm',
  color: 'white',
  mb: '2',
};

export const BoxHeadingIconContainer: CSSObject = {
  display: 'flex',
  flexDir: 'column-reverse',
};

export const BetSlipEmptyResponsibleGamblingWrapper: CSSObject = {
  mt: '4',
  mx: '0',
  mb: '2',
  'div:last-child': {
    borderBottomRadius: ['none', null, null, null, 'xl'],
  },
};
